<template>
  <div class="upload">
    <div class="upload__button-row">
      <UploadManagerButton
        :progress="generalProgress"
        :uploads-count="uploads.length"
        :button-text="uploadsButtonText"
        :is-open="isUploadsOpen"
        :general-status="generalStatus"
        @click="onUploadsButtonClicked"
      >
        <i class="fa fa-upload open__text-icon mr-20" aria-hidden="true" />
      </UploadManagerButton>
      <UnfinishedUploadsButton
        v-if="unfinishedUploads.length || isUnfinishedUploadsOpen"
        :uploads-count="unfinishedUploads.length"
        :button-text="unfinishedButtonText"
        :is-open="isUnfinishedUploadsOpen"
        @click="onUnfinishedButtonClicked"
      >
        <i class="fa fa-exclamation" aria-hidden="true" />
      </UnfinishedUploadsButton>
    </div>
    <div class="upload__lists-wrap">
      <UploadsList
        v-show="isUploadsOpen"
        :uploads="uploads"
        :is-open="isUploadsOpen"
        @stop="onStopUploadClicked"
        @resume="onResumeUploadClicked"
        @pause="onPauseUploadClicked"
        @retry="onRetryUploadClicked"
        @remove="onRemoveClicked"
        @hide="onHideClicked"
      />
      <UnfinishedList
        v-show="isUnfinishedUploadsOpen"
        :is-open="isUnfinishedUploadsOpen"
        :unfinished-uploads="unfinishedUploads"
        @file-selected="onFileReselected"
        @hide="onUnfinishedHideClicked"
        @remove-clicked="onUnfinishedRemoveClicked"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import UploadManagerButton from './UploadManagerButton';
import UnfinishedUploadsButton from './UnfinishedUploadsButton';
import UploadsList from './UploadsList';
import UnfinishedList from './UnfinishedList';

export default {
  name: 'UploadManager',
  components: {
    UploadManagerButton,
    UploadsList,
    UnfinishedUploadsButton,
    UnfinishedList,
  },

  data: () => ({
    isUploadsOpen: false,
    uploadsButtonText: 'Show uploading items',
    isUnfinishedUploadsOpen: false,
    unfinishedButtonText: 'Show unfinished uploads',
  }),

  computed: {
    ...mapGetters('uploadManager', [
      'uploads',
      'unfinishedUploads',
      'generalProgress',
      'generalStatus',
      'hasUploadingFiles',
    ]),
    hasUploadingItems() {
      return this.uploads && this.uploads.length;
    },
  },

  mounted() {
    window.addEventListener('beforeunload', (e) => {
      if (this.hasUploadingFiles) {
        const dialogText = 'You have uploading files. Are you sure you want to close the page?';
        e.returnValue = dialogText;
        return dialogText;
      }
      return null;
    });
  },

  methods: {
    onUploadsButtonClicked() {
      this.isUploadsOpen = !this.isUploadsOpen;
      if (this.isUploadsOpen) {
        this.uploadsButtonText = 'Hide uploading items';
      } else {
        this.uploadsButtonText = 'Show uploading items';
      }
      this.onUnfinishedHideClicked();
    },
    onUnfinishedButtonClicked() {
      this.isUnfinishedUploadsOpen = !this.isUnfinishedUploadsOpen;
      if (this.isUnfinishedUploadsOpen) {
        this.unfinishedButtonText = 'Hide unfinished uploads';
      } else {
        this.unfinishedButtonText = 'Show unfinished uploads';
      }
      this.onHideClicked();
    },
    onHideClicked() {
      this.isUploadsOpen = false;
      this.uploadsButtonText = 'Show uploading items';
    },
    onUnfinishedHideClicked() {
      this.isUnfinishedUploadsOpen = false;
      this.unfinishedButtonText = 'Show unfinished uploads';
    },
    onStopUploadClicked(id) {
      this.$store.dispatch('uploadManager/stopUpload', id);
    },
    onResumeUploadClicked(id) {
      this.$store.dispatch('uploadManager/resumeUpload', id);
    },
    onPauseUploadClicked(id) {
      this.$store.dispatch('uploadManager/pauseUpload', id);
    },
    onRetryUploadClicked(id) {
      this.$store.dispatch('uploadManager/retryUpload', id);
    },
    onRemoveClicked(id) {
      this.$store.dispatch('uploadManager/removeUpload', id);
    },
    onFileReselected(payload) {
      this.$store.dispatch('uploadManager/restoreUpload', {
        ...payload.uploadParams,
        files: payload.files,
        id: payload.id,
      });
      this.$store.dispatch('uploadManager/removeUnfinishedUpload', payload.id);
    },
    onUnfinishedRemoveClicked(id) {
      this.$store.dispatch('uploadManager/removeUnfinishedUpload', id);
    },
  },
};
</script>



// WEBPACK FOOTER //
// UploadManager.vue?ee031466